import React, { Fragment, useState } from "react";
import { Collapse } from "reactstrap";

import { SubAssetClassTable } from "../SubAssetClassTable/SubAssetClassTable";
import { toPascalCase } from "../../../../utils/helper";

import arrow from "../../../../../public/svg/keyboard_arrow_down.svg";

import style from "./AssetClassTable.scss";

export const AssetClassTable = ({ itemCuentas, toggle, position, currency, portfolioTotal }) => {
  const [orangeRowCollapse, setOrangeRowCollapse] = useState(true);

  const collapseOrangedata =
    itemCuentas === undefined
      ? null
      : itemCuentas.subAssetClass.map((subAssetClass, indexCuentas) => {
          return (
            <SubAssetClassTable
              subAssetClass={subAssetClass}
              toggle={toggle}
              position={position}
              currency={currency}
              portfolioTotal={portfolioTotal}
            />
          );
        });

  return (
    <Fragment>
      <tr
        className={style.collapseRow}
        onClick={() => {
          setOrangeRowCollapse(!orangeRowCollapse);
        }}
      >
        <td className={style.orangeRow}>
          <span className={style.orangeRowText}>{toPascalCase(itemCuentas.name)}</span>
          <img
            className={!orangeRowCollapse ? style.arrow : style.arrowActivated}
            src={arrow}
            alt="arrow image"
          />
        </td>
      </tr>

      <Collapse
        className={!orangeRowCollapse ? style.collapse : style.collapseActive}
        isOpen={orangeRowCollapse}
      >
        {collapseOrangedata}
      </Collapse>
    </Fragment>
  );
};
